import { useEffect, useState } from "react";
import Modal from './Modal.js';
import SearchingNavbar from "./SearchingNavbar.js";

export default function Home() {
    let [genres, setGenres] = useState([]);
    let [movies, setMovies] = useState([]);
    const [isHidden, setIsHidden] = useState(true);
    const [movieModal, setMovieModal] = useState(null);
    const [searchInput, setSearchInput] = useState('');


    const searchRequest = () => {
        //add search bar functionality here later
    };
    
    function handleOpenModal() {
        setIsHidden(false);
    }    

    const handleModal = ({ movie }) => {
        handleOpenModal();
        setMovieModal(movie);
    }

    useEffect(() => { 
        async function getMoviesFromGenre(genre) {
            let response = await fetch(`https://api.themoviedb.org/3/discover/movie?api_key=${process.env.REACT_APP_TMDB_API_KEY}&language=en-US&sort_by=popularity.desc&include_adult=False&include_video=false&with_genres=${genre}&with_watch_monetization_types=flatrate`)
            let data = await response.json()

            setMovies(elem => {
                return {...elem, [genre]: data.results}
            });
        }

        genres.forEach(genre => getMoviesFromGenre(genre.id))
        
    }, [genres]) 

    useEffect(() => {
        async function getMovieGenres() {
            let response = await fetch(`https://api.themoviedb.org/3/genre/movie/list?api_key=${process.env.REACT_APP_TMDB_API_KEY}&language=en-US`);
            let data = await response.json()

            setGenres(data.genres);
        }

        getMovieGenres();
    }, [])

    return (
        <>
            {/* <nav className="MApp-toolbar bg-primary">
                <h1 className="text-white ps-5">MApp</h1>
                <div className="logo ps-4 ms-4 mt-3">
                    <h3 className="text-white">The Movie App</h3>
                    <i className="fa-regular fa-map"></i>
                </div>
                
                <div className="search-bar">
                    <label className="me-1 text-white" htmlFor="">Search</label>
                    <input className="search-box bg-dark text-white" type="text" onChange={(e) => setSearchInput(e.target.value)} onKeyUp={e => e.key === 'Enter' ? searchRequest() : null} />
                </div>
            </nav> */}
            <div className="main-content">
                <SearchingNavbar/>
                <div className="landing-page text-white">
                <Modal isHidden={isHidden} setIsHidden={setIsHidden} movieModal={movieModal} setMovieModal={setMovieModal} />
                <ul className="d-flex flex-column overflow-hidden p-0">
                    {genres.map(function (genre, rowIndex) {
                        return (
                            <div className="" key={`div${rowIndex}`}>
                                <h1 className="genre-name pe-5" key={`h1${rowIndex}`}>{genre.name}</h1>
                                <li className="d-flex flex-row overflow-scroll" key={genre.id}>
                                {movies[genre.id] !== undefined && movies[genre.id].map((movie, cellIndex) => {
                                    
                                        const moviePath = `https://image.tmdb.org/t/p/w300/${movie.poster_path}`

                                            return (
                                                <div className="movie-holder m-2 w-1 h-100 movie2" style={{background: `url(${moviePath})`}} key={`${genre.name}-${movie.id}`} onClick={() => handleModal({ movie })}>
                                                </div>
                                            )
                                        })}
                                    </li>
                                </div>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </>
    )
}